import {
  FormFieldBlueprint,
  createFormField,
} from '@backstage/plugin-scaffolder-react/alpha';
import {
  OwnerEmailPicker,
  validateOwnerEmail,
} from './OwnerEmailPickerExtension';

export const OwnerEmailPickerFieldExtension = FormFieldBlueprint.make({
  name: 'owner-email-picker',
  params: {
    field: async () =>
      createFormField({
        name: 'OwnerEmailPicker',
        component: OwnerEmailPicker,
        validation: validateOwnerEmail,
      }),
  },
});
